export default __webpack_public_path__ + "assets/images/2aa72319640139f6de74b24e2f2c5d0c.svg";